import { WheelCircumferenceSelectionComponent } from "@/components/Elemnt/RemoteSensors/WheelCircumferenceSelectionComponent";
import { useParams } from "react-router";

function WheelCircumferencePage() {
  const { appToken = "", remoteSensorId = "" } = useParams();
  return (
    <WheelCircumferenceSelectionComponent appToken={appToken} remoteSensorId={+remoteSensorId} />
  );
}

export default WheelCircumferencePage;
